export default __webpack_public_path__ + "static/media/goncharov.e389b59e.mp4";